export const data = [
  [
      {
          id: "1",
          name: "Marek S.",
          img: require("./img/1.jpg")
      },
  ],
  [
      {
          id: "2",
          name: "Marta K.",
          img: require("./img/2.jpg")
      },
      {
          id: "3",
          name: "Katarzyna S.",
          img: require("./img/3.jpg")
      },
  ],
  [
        {
            id: "4",
            name: "Weronika M.",
            img: require("./img/4.jpg")
        },
        {
            id: "5",
            name: "Patryk C.",
            img: require("./img/5.jpg")
        }, 
        {
            id: "6",
            name: "Marcin J.",
            img: require("./img/6.jpg")
        },
      {
          id: "7",
          name: "Mateusz B.",
          img: require("./img/7.jpg")
      },
      {
          id: "8",
          name: "Agnieszka K.",
          img: require("./img/8.jpg")
      }, 
      {
          id: "9",
          name: "Maximus S.",
          img: require("./img/9.jpg")
      },
      {
        id: "10",
        name: "Paulina B.",
        img: require("./img/10.jpg")
    },
  ]

]